import { Components, Theme } from '@mui/material/styles'

export const inputCustomization: Components<Theme> = {
  MuiButton: {
    styleOverrides: {
      root: ({ theme }) => ({
        width: 'fit-content',
        border: '1px solid',
        borderColor: theme.palette.secondary.main,
        boxShadow: '0px 6px 6px 0px #00000080',
        padding: '16px 40px',
        borderRadius: '20px',
        fontSize: '18px',
        fontWeight: 600
      })
    }
  },
  MuiIconButton: {
    styleOverrides: {
      root: {
        variants: [
          {
            props: {
              size: 'large'
            },
            style: {
              width: '64px',
              height: '64px'
            }
          }
        ]
      }
    }
  },
  MuiInputBase: {
    styleOverrides: {
      input: {
        padding: '0px !important',
        color: '#0E213B',
        '::placeholder': {
          color: '#0E213B'
        }
      }
    }
  }
}
